import { Breadcrumb } from "antd";
import React, { useMemo } from "react";
import ButtonWrapper from "../../../components/reuseComp/ButtonWrapper";
import { useMessageApi } from "../../../../provider/AntdNotification";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SiteManagerTable from "./ServiceTable";
import { IServicePayloadAndResponse } from "../../../../types/api/service";
import { useServiceDelete, useServiceList } from "../../../../hooks/api/service/hooks";
import ServiceForm from "./ServiceForm";

const MainServiceComp: React.FC<{ allowURLStateUpdate?: boolean }> = ({
  allowURLStateUpdate = true,
}) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const isCreatePage = location.pathname === "/website/services/create";
  const isEditPage = !!id;

  const message = useMessageApi();
  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useServiceList({
    page: 1,
    limit: 20,
    ...DEFAULT_NUQS_CONFIG,
  });

  const serviceList: IServicePayloadAndResponse[] = useMemo(
    () => data?.data || [],
    [data]
  );

  const qData = data?.qData ?? { page: 1, limit: 20 };
  const { mutate: deleteService } = useServiceDelete({ qData });

  const handleDelete = (id: string) => {
    deleteService(
      { ids: id },
      {
        onSuccess: () => {
          message.success("Service deleted successfully");
        },
        onError: (err: any) => {
          const msg =
            err?.response?.data?.message ||
            err?.message ||
            "Failed to delete Service";

          message.error(msg);
        },
      }
    );
  };

  return (
    <div className="mb-6">
      <div className=" flex justify-between items-center">
        <h1 className="text-xl sm:text-3xl  sm:mb-2">
          {isCreatePage
            ? "add Service"
            : isEditPage
            ? "Edit Service"
            : "Services"}
        </h1>
        {!isCreatePage && !isEditPage && (
          <ButtonWrapper
            className="bg-primary text-white"
            onClick={() => navigate("/website/services/create")}
          >
            Create Service
          </ButtonWrapper>
        )}
      </div>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Dashboard", href: "/" }, { title: "Services" }]}
        />
      </div>
      <div>
        {isCreatePage || isEditPage ? (
          <ServiceForm qData={qData} id={id} />
        ) : (
          <SiteManagerTable
            {...{
             data: serviceList,
              refetch,
              qData,
              DEFAULT_NUQS_CONFIG,
              loading: isFetching,
              handleDelete,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default MainServiceComp;
